import app from '@/main';
import Home from '@/views/home/';
import ApplicationsSupplier from '@/views/applications/supplier/';
import ApplicationsSeller from '@/views/applications/seller/';
import ApplicationsCarrier from '@/views/applications/carrier/';
import ApplicationsInteriorDesigner from '@/views/applications/interiorDesigner/';

export default [
  {
    path: '*',
    redirect: () => {
      setTimeout(() => {
        app.$notify({
          title: 'Sayfa Bulunamadı',
          text: 'Geçersiz bir url girdiniz.',
          type: 'danger',
        });
      });

      return {
        name: 'home',
      };
    },
  },
  {
    name: 'home',
    path: '/',
    component: Home,
  },
  {
    path: '/:id([a-f\\d]{24})?',
    redirect: to => {
      const { params } = to;
      return { name: 'applications.supplier', params };
    },
  },
  {
    name: 'applications.supplier',
    path: '/tedarikci-ol/:id([a-f\\d]{24})?',
    component: ApplicationsSupplier,
    props: true,
  },
  {
    name: 'applications.seller',
    path: '/satis-noktasi-ol/:id([a-f\\d]{24})?',
    component: ApplicationsSeller,
    props: true,
  },
  {
    name: 'applications.carrier',
    path: '/tasiyici-ol',
    component: ApplicationsCarrier,
    props: true,
  },
  {
    name: 'applications.interiorDesigner',
    path: '/ic-mimar-hizmeti',
    component: ApplicationsInteriorDesigner,
    props: true,
  },
];
